export default "__VITE_ASSET__CatUeI3u__"